import React from 'react'
import { DateTime } from 'luxon'
import { useController, Control, FieldError, RegisterOptions } from 'react-hook-form'

import { Box, FormHelperText, TextField } from '@mui/material'
import { DatePicker } from '@mui/lab'

type Props = {
  control: Control
  id: string
  label: string
  error: FieldError
  rules?: RegisterOptions
}

function DateField({ control, id, label, error, rules }: Props) {
  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    control,
    name: id,
    rules,
    defaultValue: null,
  })

  return (
    <>
      <FormHelperText>{label}</FormHelperText>
      <DatePicker
        inputRef={ref}
        value={value}
        onChange={(value) => {
          if (!value || value.invalid) {
            onChange(value)
            return
          }
          onChange((value as DateTime).toISO())
        }}
        renderInput={(params) => (
          <TextField fullWidth id={id} name={id} color="success" {...params} onBlur={onBlur} error={!!error} />
        )}
      />
      <Box height={20}>
        <FormHelperText error>{error?.message}</FormHelperText>
      </Box>
    </>
  )
}

export default DateField
